export default "__VITE_ASSET__DInqnAe7__"